import type { HouseAttributeConfig } from '../../../hooks/usePrhHouseOPC';
import { useHippoText } from '../../../hooks/useHippoText';
import { Link } from '@flos/react-ui';
import { useState } from 'react';

const AttributeTitle = ({
    attributeConfig
}: {
    attributeConfig: HouseAttributeConfig;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const [showInfoModal, setShowInfoModal] = useState(false);
    const closeModal = (): void => {
        setShowInfoModal(false);
    };

    if (!attributeConfig.modalInformation) {
        return <>{getHippoText(attributeConfig.hippoLabel)}</>;
    }
    return (
        <>
            <Link
                className="u-color-primary-2-base u-Normalwrap"
                onClick={() => {
                    setShowInfoModal(true);
                }}
            >
                <span>{getHippoText(attributeConfig.hippoLabel)}</span>
            </Link>
            {showInfoModal && attributeConfig.modalInformation && (
                <attributeConfig.modalInformation.modalType
                    showModal={showInfoModal}
                    modalProps={attributeConfig.modalInformation.modalProps}
                    closeModal={closeModal}
                />
            )}
        </>
    );
};

export default AttributeTitle;
